module.exports = __webpack_public_path__ + "img/passionfruit-350x184.9710323e.jpg";